import { render, staticRenderFns } from "./TrafficSending.vue?vue&type=template&id=2e4e0d72&"
import script from "./TrafficSending.vue?vue&type=script&lang=js&"
export * from "./TrafficSending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports